import type { Invoice, InvoiceStatus } from '~/models/Invoices/Invoice'
import { PaginatedArrayService } from './serviceLivePaginatedArray'
import {
  query,
  where,
  getCountFromServer,
  documentId,
} from 'firebase/firestore'

export class InvoiceService extends PaginatedArrayService<Invoice> {
  constructor() {
    super('Invoices')
  }

  public listenForStatus(status: InvoiceStatus): void {
    const listenQuery = query(this.collection, where('Status', '==', status))
    this.listen(listenQuery)
  }

  public listenForId(invoiceId: string): void {
    const listenQuery = query(
      this.collection,
      where(documentId(), '==', invoiceId),
    )
    this.listen(listenQuery)
  }

  public async getCountByStatus(status: InvoiceStatus): Promise<number> {
    const countQuery = query(this.collection, where('Status', '==', status))

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
